import {
  CLEAR_SELECTED_TAB,
  GET_SELECTED_TAB,
  SET_SELECTED_TAB,
} from "./SelectedTabTypes";

const getSelectedTab = () => {
  return {
    type: GET_SELECTED_TAB,
  };
};

const setSelectedTab = (data) => {
  return {
    type: SET_SELECTED_TAB,
    payload: data,
  };
};

const clearSelectedTab = (data) => {
  return {
    type: CLEAR_SELECTED_TAB,
    payload: data,
  };
};
const SelectedTabAction = {
  getSelectedTab,
  setSelectedTab,
  clearSelectedTab,
};
export default SelectedTabAction;
